import { useEffect, useState } from "react";
import { Tab, Tabs, Container, Link } from "@mui/material";
import TagButton from "../components/TagButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import "./TopPersonPage.css";
import Thumbnail from "../components/Thumbnail";

const config = require("../config.json");

const RANK_BY_DIRECTORS = "topDirectors";
const RANK_BY_COMPOSERS = "topComposers";
const RANK_BY_WRITERS = "topWriters";
const RANK_BY_PRODUCERS = "topProducers";
const RANK_BY_USER = "forUser";

const DEFAULT_TAG = "default";

const PROLIFIC_TAG = "mostProlific";
const YOUNG_TAG = "youngest";
const ENGLISH_TAG = "english";
const JAPANESE_TAG = "japanese";
const FRENCH_TAG = "french";
const SHORT_FILM_TAG = "shortFilm";

export default function TopPersonPage() {
  const { user, isAuthenticated } = useAuth0(); // isAuthenticated indicates if user is logged in
  const [rankBy, setRankBy] = useState(RANK_BY_DIRECTORS);
  const navigate = useNavigate();
  const [tag, setTag] = useState(DEFAULT_TAG);
  const [persons, setPersons] = useState([]);

  const handleTabChange = (event, newValue) => {
    setRankBy(newValue);
  };

  const handleTagClick = (clickedTag) => {
    setTag(clickedTag);
  };

  const handleRowClick = (personId) => {
    navigate(`/person-info/${personId}`);
  };

  // Read the query parameters, and render the page
  useEffect(() => {
    setPersons([]);
    if (rankBy === RANK_BY_USER) {
      setTag(DEFAULT_TAG);
      fetch(
        `${
          process.env.NODE_ENV === "production"
            ? config.production_server_host
            : `${config.server_host}:${config.server_port}`
        }/user/${user.sub}/director_for_you`
      )
        .then((res) => res.json())
        .then((resJson) => setPersons(resJson));
    } else {
      setPersons([]);
      fetch(
        `${
          process.env.NODE_ENV === "production"
            ? config.production_server_host
            : `${config.server_host}:${config.server_port}`
        }/top_persons?tag=${tag}&rankBy=${rankBy}`
      )
        .then((res) => res.json())
        .then((resJson) => setPersons(resJson));
    }
  }, [rankBy, tag, isAuthenticated, user]);

  return (
    <div className="top-person-page">
      <div className="nav-bar-holding-block"></div>

      <Container style={{ color: "white", top: "60px" }}>
        <div>
          <Tabs
            value={rankBy}
            onChange={handleTabChange}
            aria-label="search tabs"
          >
            <Tab
              value={RANK_BY_DIRECTORS}
              label="Directors"
              style={{ color: rankBy === RANK_BY_DIRECTORS ? "white" : "grey" }}
            />
            <Tab
              value={RANK_BY_COMPOSERS}
              label="Composers"
              style={{ color: rankBy === RANK_BY_COMPOSERS ? "white" : "grey" }}
            />
            <Tab
              value={RANK_BY_WRITERS}
              label="Writers"
              style={{ color: rankBy === RANK_BY_WRITERS ? "white" : "grey" }}
            />
            <Tab
              value={RANK_BY_PRODUCERS}
              label="Producers"
              style={{ color: rankBy === RANK_BY_PRODUCERS ? "white" : "grey" }}
            />
            {/* {isAuthenticated && (
              <Tab
                value={RANK_BY_USER}
                label="For You"
                style={{ color: rankBy === RANK_BY_USER ? "white" : "grey" }}
              />
            )} */}
          </Tabs>

          {/* If tab is not "For You", show the filtering tags */}
          {rankBy !== RANK_BY_USER && (
            <div>
              <TagButton
                tag={PROLIFIC_TAG}
                selected={tag}
                handleTagClick={handleTagClick}
              ></TagButton>
              <TagButton
                tag={YOUNG_TAG}
                selected={tag}
                handleTagClick={handleTagClick}
              ></TagButton>
              <TagButton
                tag={ENGLISH_TAG}
                selected={tag}
                handleTagClick={handleTagClick}
              ></TagButton>
              <TagButton
                tag={JAPANESE_TAG}
                selected={tag}
                handleTagClick={handleTagClick}
              ></TagButton>
              <TagButton
                tag={FRENCH_TAG}
                selected={tag}
                handleTagClick={handleTagClick}
              ></TagButton>
              <TagButton
                tag={SHORT_FILM_TAG}
                selected={tag}
                handleTagClick={handleTagClick}
              ></TagButton>
            </div>
          )}

          {/* Show different Titles varies by the tab and tag selected */}
          {rankBy !== RANK_BY_USER && (
            <h2 style={{ color: "white", paddingLeft: "10px" }}>
              {tag === DEFAULT_TAG && "Top 30 "}
              {tag === ENGLISH_TAG && "Top 30 English"}
              {tag === JAPANESE_TAG && "Top 30 Japanese"}
              {tag === FRENCH_TAG && "Top 30 French"}
              {tag === PROLIFIC_TAG && "Most Prolific"}
              {tag === YOUNG_TAG && "Youngest"}
              {tag === SHORT_FILM_TAG && "Top 30 Short Film"}
              {rankBy === RANK_BY_DIRECTORS && " Directors"}
              {rankBy === RANK_BY_COMPOSERS && " Composers"}
              {rankBy === RANK_BY_WRITERS && " Writers"}
              {rankBy === RANK_BY_PRODUCERS && " Producers"}
            </h2>
          )}
          {/* {rankBy === RANK_BY_USER && (
            <h2 style={{ color: "white", paddingLeft: "10px" }}>
              These are the directors you don't want to miss :)
            </h2>
          )} */}

          {persons.length !== 0 && (
            <TableContainer component={Paper} style={{ maxWidth: "1200px" }}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow style={{ backgroundColor: "rgb(25, 25, 25)" }}>
                    <TableCell
                      align="center"
                      style={{
                        fontSize: "18px",
                        fontFamily: "EB Garamond, serif",
                        color: "rgb(150, 150, 150)",
                      }}
                    >
                      Rank
                    </TableCell>

                    <TableCell
                      align="center"
                      style={{
                        fontSize: "18px",
                        fontFamily: "EB Garamond, serif",
                        color: "rgb(25, 25, 25)",
                      }}
                    >
                      H
                    </TableCell>

                    <TableCell
                      align="center"
                      style={{
                        fontSize: "18px",
                        fontFamily: "EB Garamond, serif",
                        color: "rgb(150, 150, 150)",
                      }}
                    >
                      Person Name
                    </TableCell>

                    <TableCell
                      align="center"
                      style={{
                        fontSize: "18px",
                        fontFamily: "EB Garamond, serif",
                        color: "rgb(25, 25, 25)",
                      }}
                    >
                      H
                    </TableCell>

                    {tag === YOUNG_TAG ? (
                      <>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: "18px",
                            fontFamily: "EB Garamond, serif",
                            color: "rgb(150, 150, 150)",
                          }}
                        >
                          Age of the First Movie
                        </TableCell>
                      </>
                    ) : tag === PROLIFIC_TAG ? (
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "18px",
                          fontFamily: "EB Garamond, serif",
                          color: "rgb(150, 150, 150)",
                        }}
                      >
                        Number of Movies
                      </TableCell>
                    ) : (
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "18px",
                          fontFamily: "EB Garamond, serif",
                          color: "rgb(150, 150, 150)",
                        }}
                      >
                        Average Rating
                      </TableCell>
                    )}
                    <TableCell
                      align="center"
                      style={{
                        fontSize: "18px",
                        fontFamily: "EB Garamond, serif",
                        color: "rgb(150, 150, 150)",
                      }}
                    >
                      Top Movies
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {persons.map((person, index) => (
                    <TableRow
                      key={person.person_id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      style={{ backgroundColor: "rgb(25, 25, 25)" }}
                    >
                      {/* Index */}
                      <TableCell
                        component="th"
                        scope="row"
                        align="center"
                        style={{ fontWeight: "bold" }}
                      >
                        {index + 1}
                      </TableCell>

                      {/* Hide Block */}
                      <TableCell
                        component="th"
                        scope="row"
                        align="center"
                        style={{ color: "rgb(25, 25, 25)" }}
                      >
                        H
                      </TableCell>

                      {/* Person's Name */}
                      <TableCell component="th" scope="row" align="center">
                        <Link
                          onClick={() => handleRowClick(person.person_id)}
                          style={{
                            color: "white",
                            cursor: "pointer",
                            fontWeight: "bold",
                            maxWidth: "80px",
                          }}
                        >
                          {person.primary_name}
                        </Link>
                      </TableCell>

                      {/* Hide Block */}
                      <TableCell
                        component="th"
                        scope="row"
                        align="center"
                        style={{ color: "rgb(25, 25, 25)" }}
                      >
                        H
                      </TableCell>

                      {tag === YOUNG_TAG ? (
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold" }}
                        >
                          {person.first_movie_age}
                        </TableCell>
                      ) : tag === PROLIFIC_TAG ? (
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold" }}
                        >
                          {person.num_of_movies}
                        </TableCell>
                      ) : (
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold" }}
                        >
                          {person.vote && person.vote.toFixed(2)}
                        </TableCell>
                      )}

                      <TableCell component="th" scope="row" align="right">
                        {person.poster_path_1 && (
                          <Thumbnail
                            imdb_id={person.imdb_1}
                            title={person.movie_1}
                            poster_path={person.poster_path_1}
                            rating={person.rating_1}
                          ></Thumbnail>
                        )}
                        {person.poster_path_2 && (
                          <Thumbnail
                            imdb_id={person.imdb_2}
                            title={person.movie_2}
                            poster_path={person.poster_path_2}
                            rating={person.rating_2}
                          ></Thumbnail>
                        )}
                        {person.poster_path_3 && (
                          <Thumbnail
                            imdb_id={person.imdb_3}
                            title={person.movie_3}
                            poster_path={person.poster_path_3}
                            rating={person.rating_3}
                          ></Thumbnail>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </Container>
    </div>
  );
}
